<template>
  <PullRefresh
    v-model="isLoading"
    success-text="刷新成功"
    :disabled="!isLive || disabledPull || visible"
    @refresh="onRefresh"
  >
    <div v-if="!isLive || (hasFetched && curGameId && !curGameStatus)" class="pageNative flex_center">
      <div
        v-if="isNotStart"
        class="nativeStatus flex_center"
      >
        活动将于 {{ activityInfo.startTime }} 开始
      </div>
      <div
        v-else
        class="nativeStatus flex_center"
      >
        活动已结束
      </div>
    </div>
    <div v-else class="page">
      <!-- 头图 -->
      <div
        class="page_header bg_contain"
        :style="{
          backgroundImage: `url(${activityInfo.icon})`,
        }"
      >
      </div>
      <div class="main" v-if="!curGameId">
        <div class="main_top flex_a_c">
          <img class="main_title" src="https://image.hzwxbz2.cn/java-yunying/jyy_1724393322526_3f5468de0bfbe111586f7649a3c8d115.png" />
        </div>
        <div class="main_ctx">
          <div class="main_list main_games">
            <div
              v-for="g in gameList"
              :key="g.gameId"
              class="main_game flex_center border_bottom_1px"
              @click="handleGoGameItem(g)"
            >
              <div
                class="game_icon mr_6 bg_contain"
                :style="{ backgroundImage: `url(${g.gameIcon})` }"
              ></div>
              <div class="game_main flex_1">
                <div class="game_top mb_2 flex_between">
                  <div class="game_info">
                    <div class="game_title mb_6">{{ g.gameName }}</div>
                    <div class="game_desc d_flex">
                      <div class="game_score color_red_btn pr_6 mr_6">{{ g.score }}分</div>
                      <div class="game_version color_grey pr_6 mr_6">{{ g.version }}版本</div>
                      <div v-if="g.depict" class="game_depict color_grey pr_6 mr_6">{{ g.depict }}</div>
                    </div>
                  </div>
                  <div class="game_btn" @click.stop="handleGoGameItem(g, 2)">
                    参与返利
                  </div>
                </div>
                <GameTag :tags="g.tags" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="main" v-else>
        <div class="main_top flex_a_c">
          <img class="main_title mr_14" src="https://image.hzwxbz2.cn/java-yunying/jyy_1724393400650_5d1cb9970fd74ed9f56a867a785a358f.png" />
          <div class="main_rebate mb_2 color_black fs_28 bold flex_1" style="align-self: flex-end;">{{ curInfo.point }}</div>
          <div class="main_detail text_color_link text_underline fs_12" @click="onShowRewardRecord">返利点明细</div>
        </div>
        <div class="main_ctx">
          <div class="main_game flex_center mb_8"  style="padding-right: 0px;">
            <div
              class="game_icon bg_contain mr_10"
              :style="{ backgroundImage: `url(${curInfo.gameIcon})` }"
            />
            <div class="game_title" style="width: 0; flex: 1">{{ curInfo.gameName }}</div>
            <div class="game_btn" @click="handleJumpGame">去玩游戏</div>
          </div>
          <div class="main_list main_vouchers">
            <div v-for="vc in curInfo.dataList" :key="vc.voucherId" class="main_voucher flex_center border_bottom_1px">
              <div class="voucher_left flex_1">
                <div class="voucher_main flex_a_c mb_6">
                  <div
                    class="voucher_icon bg_contain mr_8"
                    :style="{ backgroundImage: `url(${vc.icon})` }"
                  />
                  <div class="voucher_info">
                    <div class="voucher_title fs_15 mb_4" style="color: #000;">{{ vc.name }}</div>
                    <div class="voucher_desc fs_12" style="color: #646464;">{{ getInValidTime(vc) }}</div>
                  </div>
                </div>
                <div class="voucher_tip" style="color: #FF4605;">消耗返利点{{ vc.point }}, 可兑换次数{{ vc.limitNum }}次</div>
              </div>
              <div
                class="voucher_btn flex_center"
                :class="{ voucher_btn_disabled: vc.limitNum === 0 }"
                @click="handleExchangeVc(vc)"
              >
                兑换
              </div>
            </div>
          </div>
          <div 
            v-if="curInfo.customStatus"
            class="main_tips fs_12 text_center mt_16 mb_4"
            @click="onShowExchange"
          >
            <span style="color: #747474">没有想要的代金券？</span>
            <span class="text_color_link pl_4 pr_4">去自选</span>
          </div>
        </div>
      </div>
      <Record
        ref="recordRef"
        :activityId="actId"
        :placeId="curGameId"
        @close="setDisabledPull"
      />
      <Exchange
        ref="exchangeRef"
        :exchangeTimes="curInfo.exchangeTimes"
        :loading="customExcLoading"
        :rate="curInfo.voucherRate"
        @sure="handleExchange"
        @close="setDisabledPull"
      />
      <ActivityPopup
        :visible.sync="visible"
        :headerStyle="{background: '#FFBC5C'}"
        confirmButtonColor="#FFBC5C"
        cancelButtonColor="#BCBCBC"
        v-bind="feedback"
        @confirm="feedback.onSure"
        @cancel="feedback.onCancel"
      >
        <template v-if="feedbackType === 0">
          <div class="avc flex_center color_black mb_32">
            <div
              class="avc_img bg_contain mr_16"
              :style="{ backgroundImage: `url(${curVc.icon})` }"
            />
            <div class="avc_info">
              <div class="avc_title fs_18 mb_8">{{ curVc.name }}</div>
              <div class="avc_desc fs_12" style="color: #646464">失效时间: {{ getInValidTime(curVc) }}</div>
            </div>
          </div>
          <p class="fs_18 text_center color_black">兑换后代金券将存放在</p>
          <p class="fs_18 text_center color_black">【我的】--【代金券】</p>
        </template>
      </ActivityPopup>
    </div>
  </PullRefresh>
</template>

<script>
import { setPageTitle, setRightTxt, clickRightTxt } from "@/bridge/AppJsBridge";
import { PullRefresh } from "vant";
import ActivityPopup from "@/components/btBox/ActivityPopup";
import EventTrack from '@/mixins/eventTrack'
import LinkTo from '@/mixins/linkTo'
import { CDN_URL_1 } from "@/config";
import {
  getRegisterRebateInfo, getRegisterRebateList, getRegisterRebateGame,
  exchangeVoucherApi, customExchangeVoucherApi, checkVoucherPlaceApi,
} from '@/apis/btBoxActivity'
import GameTag from './gameTag.vue'
import Record from './record'
import Exchange from './exchange'
import { formatMinutes } from '@/libs/utils'
const errCodeMap = {
  95001: '活动已结束',
  95002: '活动已结束',
  95003: '自定义兑换已关闭',
  95004: '兑换代金券不存在',
  95008: '代金券发放失败',
}
export default {
  data () {
    return {
      activityInfo: {
        id: '',
        startTime: '',
        endTime: '',
        icon: '',
        title: '',
      },
      gameList: [],
      curInfo: {},
      curVc: {},
      hasFetched: false,
      isLoading: false,
      feedbackType: 0,
      excLoadingId: -1,
      visible: false,
      customExcLoading: false,
      curGameStatus: false,
      errCode: '',
      disabledPull: false,
    }
  },
  mixins: [EventTrack, LinkTo],
  components: {
    PullRefresh,
    GameTag,
    Record,
    Exchange,
    ActivityPopup,
  },
  computed: {
    actId () {
      return this.activityInfo.id || this.$route.query.id
    },
    curGameId () {
      return this.$route.query.placeId * 1
    },
    isLive () {
      const { id } = this.activityInfo
      if (!this.hasFetched) return true
      if (!id && this.hasFetched) return false
      return !this.isNotStart && !this.isPassed
    },
    isPassed () {
      const { endTime } = this.activityInfo
      const now = Date.now()
      return now > new Date(endTime).getTime()
    },
    isNotStart () {
      const { startTime } = this.activityInfo
      const now = Date.now()
      return now < new Date(startTime).getTime()
    },
    feedback () {
      return this.feedbackMap[this.feedbackType]
    },
    feedbackMap () {
      return [
        {
          title: '确认兑换',
          message: [],
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          showCancelButton: true,
          onSure: () => {
            this.handleSure()
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '提示',
          message: [
            errCodeMap[this.errCode],
            '可联系客服'
          ],
          confirmButtonText: '联系客服',
          onSure: () => {
            this.onRelationServer()
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
        {
          title: '兑换成功',
          confirmButtonText: '确认',
          message: [
            '代金券将于 24h 内存放到',
            '【我的】--【代金券】',
          ],
          onSure: () => {
            this.triggerVisible(false)
          },
          onCancel: () => {
            this.triggerVisible(false)
          }
        },
      ]
    },
  },
  mounted () {
    // 如果浏览器没有调用接口，可以加上 IS_DEV 的 query 参数
    const { query } = this.$route
    if (query.IS_DEV) {
      this.init()
    }
    this.getAppToken(true)
  },
  activated () {
    setPageTitle(this.activityInfo.title)
    if (this.activityInfo.title) {
      setRightTxt('活动规则');
    }
  },
  methods: {
    getActivityInfo () {
      this.init()
    },
    init () {
      const fn = this.curGameId ? this.onCheckGamePlaceValid : this.getActInfo
      return fn().then(res => {
        setPageTitle(this.activityInfo.title || '')
      }).finally(() => {
        this.setHeaderContent()
        this.hasFetched = true
      })
    },
    onRefresh () {
      this.init().finally(res => {
        setTimeout(() => {
          this.isLoading = false
        }, 300)
      })
    },
    getActInfo () {
      return getRegisterRebateInfo({
        activityId: this.actId,
      }).then(res => {
        this.activityInfo = res.data || {
          id: '',
          startTime: '',
          endTime: '',
          icon: '',
          title: '',
        }
        this.eventTrack({
          event: "register_voucher_page",
          event_field: this.getTrackInfo(),
        })
        this.getGameList()
      })
    },
    getGameList () {
      return getRegisterRebateList({
        activityId: this.actId,
      }).then(res => {
        this.gameList = res.data || []
      })
    },
    getVouchers (track = false) {
      return getRegisterRebateGame({
        activityId: this.actId,
        placeId: this.curGameId,
      }).then(res => {
        this.curInfo = res.data
        const { activityId, title, icon, startTime, endTime } = res.data
        this.activityInfo = {
          id: activityId,
          startTime,
          endTime,
          icon,
          title,
        }
        if (track) {
          this.eventTrack({
            event: "register_voucher_detail",
            event_field: this.getTrackInfo({
              point: this.curInfo.point,
            }, true),
          })
        }
      })
    },
    // 校验下当前会场是否有效
    onCheckGamePlaceValid () {
      return checkVoucherPlaceApi({
        activityId: this.actId,
        placeId: this.curGameId,
      }).then(res => {
        this.curInfo = {}
        this.setGameStatus(!!res.data)
        if (res.data) {
          return this.getVouchers(true)
        } else {
          this.$toast('活动已结束，去其他游戏看看吧')
          return Promise.resolve({})
        }
      })
    },
    setGameStatus (f) {
      if (f) {
        this.curGameStatus = f
      } else {
        setTimeout(() => {
          this.curGameStatus = f
        }, 2000)
      }
    },
    getInValidTime (vc) {
      const { timeType, relativeInvalidTime, invalidTime } = vc
      if (timeType === 1) {
        return `${invalidTime}后失效`
      }
      if (timeType === 2) {
        return `领取${formatMinutes(relativeInvalidTime)}后失效`
      }
    },
    handleExchangeVc (vc) {
      const { limitNum, voucherId, name, point } = vc
      if (!limitNum) return
      this.eventTrack({
        event: "register_voucher_exchange",
        event_field: this.getTrackInfo({
          remind_point: this.curInfo.point,
          voucher_id: voucherId,
          voucher_name: name,
          point: point,
          limit_num: limitNum,
        }, true),
      })
      this.curVc = vc
      this.triggerVisible(true, 0)
      this.eventTrack({
        event: "register_voucher_sure_show",
        event_field: this.getTrackInfo({
          remind_point: this.curInfo.point,
          voucher_id: voucherId,
          voucher_name: name,
          point: point,
          limit_num: limitNum,
        }, true),
      })
    },
    handleSure () {
      const { voucherId, type, point, limitNum, name } = this.curVc
      if (this.excLoadingId === voucherId) return 
      this.excLoadingId = voucherId
      this.eventTrack({
        event: "register_voucher_sure_click",
        event_field: this.getTrackInfo({
          remind_point: this.curInfo.point,
          voucher_id: voucherId,
          voucher_name: name,
          point: point,
          limit_num: limitNum,
        }, true),
      })
      this.triggerVisible(false)
      exchangeVoucherApi({
        activityId: this.actId,
        placeId: this.curGameId,
        voucherId,
        type,
      }).then(res => {
        const r = res.data
        this.$toast.success('兑换成功')
        this.eventTrack({
          event: "register_voucher_exchange_result",
          event_field: this.getTrackInfo({
            remind_point: r,
            voucher_id: voucherId,
            voucher_name: name,
            point: point,
            limit_num: limitNum,
            type: 1,
          }, true),
        })
        this.getVouchers()
      })
      .catch((err) => {
        this.eventTrack({
          event: "register_voucher_exchange_result",
          event_field: this.getTrackInfo({
            remind_point: this.curInfo.point,
            voucher_id: voucherId,
            voucher_name: name,
            point: point,
            limit_num: limitNum,
            type: 2,
          }, true),
        })
        this.onErrorCode(err)
      })
      .finally(() => this.excLoadingId = -1)
    },
    // 处理兑换的错误逻辑
    onErrorCode (err) {
      const { code, msg } = err
      if ([95001, 95002].includes(code)) {
        this.$toast('活动已结束，去其他游戏看看吧')
        this.setGameStatus(false)
      } else if ([95003, 95004, 95008].includes(code)) {
        this.errCode = code 
        setTimeout(() => {
          this.triggerVisible(true, 1)
        }, 100)
      } else {
        this.$toast(msg)
      }
    },
    // 去具体游戏福利页
    handleGoGameItem (g, type = 1) {
      const { placeId, gameId, gameName } = g
      this.eventTrack({
        event: "register_voucher_button",
        event_field: this.getTrackInfo({
          type,
          place_id: placeId,
          game_id: gameId,
          game_name: gameName,
        }, true),
      })
      // this.$router.push({
      //   query: {
      //     placeId: placeId,
      //     id: this.actId,
      //   }
      // })
      // 36 -> h5活动
      this.handleGoDownload(gameId, 36)
      this.getActInfo()
    },
    // 跳转游戏
    handleJumpGame () {
      this.eventTrack({
        event: "register_voucher_button",
        event_field: this.getTrackInfo({
          type: 3
        }, true),
      })
      // 36 -> h5活动
      this.handleGoDownload(this.curInfo.gameId, 36)
    },
    // 打开奖励记录面板
    onShowRewardRecord () {
      this.eventTrack({
        event: "register_voucher_record",
        event_field: this.getTrackInfo({}, true),
      })
      this.$refs.recordRef.triggerVisible(true)
      this.setDisabledPull(true)
      this.eventTrack({
        event: "register_voucher_record_button",
        event_field: this.getTrackInfo({}, true),
      })
    },
    onShowExchange () {
      this.eventTrack({
        event: "register_voucher_custom",
        event_field: this.getTrackInfo({
          remind_point: this.curInfo.point,
        }, true),
      })
      if (!this.curInfo.exchangeTimes) {
        this.$toast.fail('自选次数已用完')
        return
      }
      this.$refs.exchangeRef.triggerVisible(true)
      this.setDisabledPull(true)
      this.eventTrack({
        event: "register_voucher_custom_show",
        event_field: this.getTrackInfo({
          remind_point: this.curInfo.point,
        }, true),
      })
    },
    setDisabledPull (f = false) {
      this.disabledPull = f
    },
    // 确认兑换
    handleExchange (num) {
      if (this.customExcLoading) return
      this.customExcLoading = true
      this.eventTrack({
        event: "register_voucher_custom_sure",
        event_field: this.getTrackInfo({
          remind_point: this.curInfo.point,
          voucher_num: num,
          point: (num / this.curInfo.voucherRate).toFixed(2),
          limit_num: this.curInfo.exchangeTimes,
        }, true),
      })
      customExchangeVoucherApi({
        activityId: this.actId,
        placeId: this.curGameId,
        money: num,
      }).then(res => {
        this.$refs.exchangeRef.triggerVisible(false)
        this.$refs.exchangeRef.clear()
        this.triggerVisible(true, 2)
        this.getVouchers()
        this.eventTrack({
          event: "register_voucher_exchange_result",
          event_field: this.getTrackInfo({
            remind_point: res.data,
            limit_num: this.curInfo.exchangeTimes,
            type: 1,
          }, true),
        })
      }).catch((err) => {
        this.eventTrack({
          event: "register_voucher_exchange_result",
          event_field: this.getTrackInfo({
            remind_point: this.curInfo.point,
            limit_num: this.curInfo.exchangeTimes,
            type: 2,
          }, true),
        })
        this.onErrorCode(err)
      }).finally(() => {
        this.customExcLoading = false
      })
    },
    triggerVisible (v, type) {
      if (type !== undefined) {
        this.feedbackType = type
      }
      this.visible = v
    },
    // 设置顶部内容
    setHeaderContent() {
      setRightTxt("活动规则");
      clickRightTxt(() => {
        this.eventTrack({
          event: "register_voucher_rule",
          event_field: this.getTrackInfo(),
        })
        this.triggerVisible(false)
        this.handleGoRulePage(16)
      });
    },
    getTrackInfo (params = {}, needGameInfo = false) {
      const gameInfo = {
        game_id: this.curInfo.gameId,
        game_name: this.curInfo.gameName,
        place_id: this.curGameId,
      }
      return JSON.stringify({
        activity_id: this.actId,
        activity_name: this.activityInfo.title,
        ...(needGameInfo ? gameInfo : {}),
        ...params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.page, .pageNative {
  position: relative;
  min-height: 100vh;
  background-color: #FFCC84;
  transition: 0.2s all ease;
  color: #fff;
}

.page {
  padding-top: 196px;
  padding-bottom: 12px;
  position: relative;
  ::v-deep .popup_content {
    p {
      color: #000; 
    }
  }
}

.page_header {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 214px;
}
.main {
  position: relative;
  background-color: #FFCC84;
  border-radius: 12px;
  padding: 8px;
  padding-bottom: 18px;
  // max-height: calc(100vh - 196px - 12px);
  .main_top {
    height: 36px;
    margin-bottom: 6px;
    padding: 0 8px;
    .main_title {
      height: 100%;
    }
  }
  .main_ctx {
    // max-height: calc(100vh - 196px - 12px - 36px - 24px);
    // overflow: auto;
    padding: 12px 14px;
    border-radius: 16px;
    background-color: #fff;
    color: #000;
  }
  .main_game {
    padding: 8px 8px 8px 0;
    .game_icon {
      width: 60px;
      height: 60px;
      border-radius: 6px;
    }
    .game_title {
      // width: 0;
      // flex: 1;
    }
    .game_main {
      .game_desc {
        font-size: 10px;
      }
      .game_score, .game_version {
        border-right: 1px solid #b6b6b6;
      }
      .game_info {
        flex: 1;
        width: 0;
      }
    }
    .game_btn {
      padding: 10px 18px;
      font-size: 12px;
      border-radius: 100px;
      color: #fff;
      background-color: #FF5A3F;
    }
  }
  .main_voucher {
    padding: 8px 8px 4px 10px;
  }
  .voucher_left {

  }
  .voucher_icon {
    width: 38px;
    height: 38px;
  }
  .voucher_title {

  }
  .voucher_tip {
    font-size: 9px;
  }
  .voucher_btn {
    background-color: #FFB83C;
    color: #fff;
    border-radius: 100px;
    font-size: 12px;
    padding: 6px 24px;
  }
  .voucher_btn_disabled {
    background-color: #BCBCBC;
  }
}
.border_bottom_1px {
  border-bottom: 1px solid #e8e8e8; 
}

.avc {
  .avc_img {
    width: 45px;
    height: 45px;
  }
}
</style>
